// Settings destination (BUILD-356 scaffolds navigation; real settings are built
// later). Renders the shell topbar + an "à venir" placeholder. On mobile, logout
// is not part of the bottom tab bar, so its only home is here — the labelled
// button below is shown on mobile and hidden on desktop (where the rail carries
// logout). When real settings land, account actions move into this page.
import { WordShellTopbar } from '@/components/words/word-shell-topbar';
import { useLogout } from '@/lib/use-logout';

/** Placeholder settings page (feature not yet implemented). */
export function SettingsPage() {
  const { handleLogout, pending } = useLogout();

  return (
    <>
      <WordShellTopbar />
      <div className="words-content-stub">
        <span className="material-symbols-rounded words-content-stub__icon" aria-hidden="true">
          settings
        </span>
        <h2 className="words-content-stub__title">Réglages</h2>
        <p className="words-content-stub__text">À venir.</p>

        <button type="button" className="settings-logout" disabled={pending} onClick={handleLogout}>
          <span className="material-symbols-rounded" aria-hidden="true">
            logout
          </span>
          Se déconnecter
        </button>
      </div>
    </>
  );
}
